<template>
  <BitsemsHeaderAndFooter>
    <br />
    <br />
    <v-container class="fill-height" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="5" md="5" xs="5" class="rounded-corners">
          <v-card class="elevation-12 rounded-corners">
            <v-form v-model="valid">
              <v-toolbar dark flat>
                <v-toolbar-title>Create Account</v-toolbar-title>
                <v-spacer />
              </v-toolbar>
              <v-card-text>
                <v-select
                  :rules="nameRules"
                  prepend-icon="house"
                  :items="schools"
                  label="Switch School"
                  v-model="selectedSchoolEmis"
                  item-text="schname"
                  item-value="emis"
                ></v-select>
                <v-text-field
                  label="Name"
                  name="name"
                  prepend-icon="person"
                  type="text"
                  v-model="name"
                  :rules="nameRules"
                />

                <v-text-field
                  label="Email"
                  name="email"
                  prepend-icon="email"
                  type="text"
                  v-model="email"
                  :rules="emailRules"
                />

                <v-text-field
                  label="Tel #"
                  name="tel"
                  prepend-icon="phone_callback"
                  type="text"
                  v-model="tel"
                  :rules="nameRules"
                />

                <v-text-field
                  id="password"
                  label="Password"
                  name="password"
                  prepend-icon="lock"
                  type="password"
                  v-model="password"
                  :rules="nameRules"
                />
              </v-card-text>
              <v-card-actions>
                <v-btn
                  text
                  x-small
                  color="var(--theme-hover-color)"
                  dark
                  @click.prevent="$router.push('/bitsems-login')"
                >Login</v-btn>
                <v-spacer />
                <v-btn dark @click.prevent="register">Submit</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </BitsemsHeaderAndFooter>
</template>

<script>
import axios from "@/plugins/axios";
import BitsemsHeaderAndFooter from "@/components/Bitsems/BitsemsHeaderAndFooter";
import { mapGetters } from "vuex";

export default {
  computed: mapGetters(["getThemeColor", "getUserSchool"]),
  mounted() {
    axios.getData("/get-all-schools").then(schools => {
      this.schools = schools;
    });
  },
  components: {
    BitsemsHeaderAndFooter
  },
  data() {
    return {
      schools: [],
      selectedSchoolEmis: null,
      valid: false,
      name: null,
      email: null,
      tel: null,
      password: null,
      nameRules: [v => !!v || "This Field is required"],
      emailRules: [
        v => !!v || "Valid E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ]
    };
  },

  methods: {
    register() {
      if (
        this.selectedSchoolEmis == null ||
        this.name == null ||
        this.email == null ||
        this.tel == null ||
        this.password == null
      ) {
        alert("All Fields Are Required!");
      } else {
        const axiosPromise = axios.postData("/auth/register", {
          name: this.name,
          email: this.email,
          tel: this.tel,
          password: this.password,
          emis: this.selectedSchoolEmis
        });

        axiosPromise.then(response =>
          this.$router.push({ name: "bitsems-login" })
        );
      }
    } //end of login method
  }
};
</script>

<style lang="scss" scoped>
</style>